
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { CategoryType, CategoryPayloadType } from "@/common/types/category";

export async function categoryList(
    type: string,
    query?: QueryType
) {
    const queryString = formatQueryString({ type, ...query });

    return await clientAxios.get(
        `common/category/list${queryString}`
    );
}

export async function categoryGet(
    category_id: string
) {
    return await clientAxios.get(
        `common/category/${category_id}/show`
    );
}

export async function categoryAdd(
    payload: CategoryPayloadType
) {
    return await clientAxios.post(
        `common/category/create`,
        payload
    );
}

export async function categoryPatch(
    category_id: string,
    payload: Partial<CategoryType>
) {
    return await clientAxios.patch(
        `common/category/${category_id}/patch`,
        { payload }
    );
}

export async function categoryDel(
    category_id: string,
) {
    return await clientAxios.del(
        `common/category/${category_id}/delete`,
    );
}
